<template>
    <span>
        <kgr-icon-edit
            :title="$t('Kind auf die Warteliste setzen')"
            class="kgr-table__action kgr-clickable kgr-clickable--touchy"
            @click="checkWaitlistAction()"
        />

        <kgr-generic-modal
            v-model="showModal"
            :headline="$t('Hinweis')"
        >
            <div v-if="primaryContactOptions !== null">
                <strong class="kgr-text kgr-text--bold" v-html="$t('childRegistration.toWaitlist.primaryContact.emailExists')"></strong>
                <br />
                <br />
                <kgr-radio
                    v-model="selectionPrimaryContact"
                    :options="primaryContactOptions"
                />
                <br />
            </div>

            <div v-if="secondaryContactOptions !== null">
                <strong class="kgr-text kgr-text--bold" v-html="$t('childRegistration.toWaitlist.secondaryContact.emailExists')"></strong>
                <br />
                <br />
                <kgr-radio
                    v-model="selectionSecondaryContact"
                    :options="secondaryContactOptions"
                />
            </div>

            <template #footer>
                <kgr-button
                    class="kgr-col"
                    @click="moveToWaitlistWithSelection()"
                >{{ $t('saveChanges') }}</kgr-button>
                <kgr-button
                    type="grey"
                    @click="cancel()"
                >{{ $t('cancel') }}</kgr-button>
            </template>
        </kgr-generic-modal>
        <slot></slot>
    </span>
</template>

<script>
import Button from '../../common/form/button/KgrButton.vue';
import GenericModal from '../../common/modal/GenericModal.vue';
import GenericRadio from '../../common/form/radio/GenericRadio.vue';
import IconEdit from '../../common/icon/IconEdit.vue';

export default {
    components: {
        'kgr-generic-modal': GenericModal,
        'kgr-button': Button,
        'kgr-icon-edit': IconEdit,
        'kgr-radio': GenericRadio,
    },
    props: {
        registrationChildId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            selectionPrimaryContact: 'create',
            selectionSecondaryContact: 'create',
            showModal: false,
            primaryContactOptions: null,
            secondaryContactOptions: null,
        }
    },
    methods: {
        cancel() {
            this.showModal = false;
        },
        moveToWaitlistWithSelection() {
            this.moveToWaitlist(
                {
                    'primaryContact': this.selectionPrimaryContact,
                    'secondaryContact': this.selectionSecondaryContact,
                }
            )
        },
        checkWaitlistAction() {
            this.moveToWaitlist()
        },
        moveToWaitlist(data)
        {
            const moveToWaitlistUrl = `/backend/child_registration/towaitlist/${this.registrationChildId}`;
            jQuery.post(moveToWaitlistUrl,data ?? {}, response =>
            {
                if(response.success == '1')
                {
                    $('#row'+this.registrationChildId).remove();
                    this.showModal = false;
                } else {
                    this.primaryContactOptions = this.buildRadioOptions(response.primaryContact.parents);
                    this.secondaryContactOptions = this.buildRadioOptions(response.secondaryContact ? response.secondaryContact.parents : null);
                    this.showModal = this.primaryContactOptions !== null || this.secondaryContactOptions !== null;
                }
            });
        },
        buildRadioOptions(parents) {
            if(!parents || parents.length === 0)
            {
                return null;
            }
            const options = {};
            parents.forEach(parent => {
                options[this.$t('childRegistration.toWaitlist.overtakeParent', {fullname: parent.fullname})] = parent.id;
            });
            options[this.$t('Bezugsperson aus Registrierungsdaten erstellen')] = 'create';
            options[this.$t('Keine Bezugsperson erstellen')] = 'noCreate';

            return options;

        }
    }
}
</script>
